<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 20px;
  h3 {
    font-size: 16px;
  }
  .title {
    font-size: 14px;
  }
  .order {
    font-size: 12px;
  }
  .nav {
    display: flex;
    justify-content: space-between;
  }
  .order__info {
    border: 1px solid rgba(245, 245, 245, 1);
    padding: 20px;
    margin-bottom: 19px;
  }
  .pay__info {
    padding-top: 25px;
  }
}
</style>
<template>
  <div class="container">
    <div class="nav">
      <div class="info">
        <h3>请核对订单信息</h3>
        <p class="order">订单号: {{ vo.out_trade_no }}</p>
      </div>
      <h3 class="money">{{ vo.subject }} 已支付: {{ vo.amount | currency("¥", 2) }}</h3>
    </div>
    <div class="order__info">
      <p v-if="vo.user_info">
        {{ vo.user_info.legal_person }} {{ vo.user_info.com_name }}
        {{ vo.user_info.com_address }} {{ vo.user_info.con_details }}
      </p>
      <p>{{ vo.project_name }}</p>
      <p>{{ vo.version_name }}</p>
      <p v-if="vo.platform_list && vo.platform_list.length">{{ vo.platform_list.join("、") }}</p>
      <p>1级功能: {{ vo.feature_count }}个</p>
      <p>2级功能: {{ vo.function_count }}个</p>

    <div class="pay__info">
      <p>支付方式: {{ map[vo.method] }}</p>
      <p>创建时间: {{ vo.hex_create_time | toTime }}</p>
      <p>付款时间: {{ vo.pay_time | toTime }}</p>
    </div>
    </div>
  </div>
</template>
<script>
import { stringify } from 'query-string'
import qrcode from 'qrcode'
export default {
  data () {
    return {
      // mock
      vo: {
        method: 'wxpay',
        subject: '预付款'
      },
      map: {
        wxpay: '微信支付',
        alipay: '支付宝支付'
      }
    }
  },
  beforeMount () {
    this.fetchOrder().then(r => {
      this.vo = {
        ...this.vo,
        ...r
      }
    })
  },
  methods: {
    fetchOrder () {
      return this.$post('/wuwei/api/orders/payProcess', {
        order_id: this.$route.query.order_id
      }).then(data => {
        return data.result
      })
    },
    postPay () {
      return this.$post('/wuwei/api/orders/payment', {
        returnUrl: `${window.location.origin}/#/pay/process/done?${stringify(this.$route.query)}`,
        order_id: this.$route.query.order_id,
        method: this.vo.payMethod
      }).then(data => {
        return data.result
      })
    },
    changePayType (key) {
      this.vo.payType = key
    },
    closeWxPay () {
      this.vo.wxPay = false
      clearTimeout(this.loopTimer)
    },
    // 心跳检测
    loopCheckPay () {
      const d = 1000
      this.loopTimer = setTimeout(() => {
        this.fetchOrder().then(r => {
          if (r.pay_status) {
            clearTimeout(this.loopTimer)
            this.loopTimer = null
            this.$router.push('/pay/process/done')
          } else {
            this.loopCheckPay()
          }
        })
      }, d)
    },
    qrcode (text, el) {
      return new Promise((resolve, reject) => {
        qrcode.toCanvas(el, text, {
          width: 212,
          height: 212,
          errorCorrectionLevel: 'H'
        }, err => {
          if (err) {
            reject(err)
            return
          }
          resolve()
        })
      })
    },
    // 微信支付
    wxpay () {
      this.postPay().then(result => {
        if (result && result.qr_code) {
          this.vo.wxPay = true
          this.$nextTick(() => {
            this.qrcode(result.qr_code, this.$refs.qr).then(this.loopCheckPay.bind(this))
          })
        }
      })
    },
    // 支付宝支付
    alipay () {
      this.postPay().then(result => {
        if (result && result.qr_code) {
          window.location.href = result.qr_code
        }
      })
    },
    onPay () {
      if (typeof this[this.vo.payMethod] === 'function') {
        this[this.vo.payMethod]()
      }
    }
  }
}
</script>
